import React, { useEffect, useRef, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './PdfViewer.css';
import ZoomInIcon from '../../assets/images/ZoomIn.svg';
import ZoomOutIcon from '../../assets/images/ZoomOut.svg';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface PdfViewerProps {
    src: string;
    source?: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ src, source }) => {
    const [numPages, setNumPages] = useState<number | null>(null);
    const [scale, setScale] = useState(1);
    const pdfViewerRef = useRef<HTMLDivElement>(null);

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    const zoomIn = () => {
        setScale((prevScale) => Math.min(prevScale + 0.2, 2));
    };

    const zoomOut = () => {
        setScale((prevScale) => Math.max(prevScale - 0.2, 1));
    };

    return (
        <div
            className={`pdf-viewer ${source === 'resource viewer' && 'flex items-center justify-center'}`}
            ref={pdfViewerRef}
            tabIndex={-1} // Make the div focusable
        >
            <div className="zoom-controls absolute md:right-[8rem] md:top-[4rem] lg:right-[11.5rem] lg:top-[2rem] flex gap-4 z-10">
                <button onClick={zoomOut} className="bg-white rounded-md p-1">
                    <img
                        src={ZoomOutIcon}
                        alt="Zoom Out"
                        className="lg:w-6 lg:h-6 md:w-5 md:h-5"
                    />
                </button>
                <button onClick={zoomIn} className="bg-white rounded-md p-1">
                    <img
                        src={ZoomInIcon}
                        alt="Zoom In"
                        className="lg:w-6 lg:h-6 md:w-5 md:h-5"
                    />
                </button>
            </div>
            <Document
                file={src}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={(error) =>
                    console.error('PDF loading error:', error)
                }
            >
                {Array.from(new Array(numPages), (el, index) => (
                    <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        renderAnnotationLayer={true}
                        renderTextLayer={false}
                        scale={scale}
                    />
                ))}
            </Document>
        </div>
    );
};

export default PdfViewer;
